/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'more-vertical': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" d="M10.5 14.875a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm0-6.125a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm0-6.125a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z" _fill="#566473" fill-rule="evenodd"/>'
  }
})
